export const styles = {
  list: {
    '> div': {
      borderRadius: '12px 12px 0 0',
    },
  },
  controls: {
    backgroundColor: 'common.white',
    padding: '12px 20px',
    boxShadow: '0px 12px 20px -15px',
    borderRadius: '0 0 12px 12px',
  },
  clearButton: {
    color: 'common.black',
  },
  input: {
    maxHeight: '40px',
  },
  clearIcon: {
    transform: 'translateY(-3px)',
  },
};
